// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"625":"061e86c4","820":"db9970c2"}[chunkId] + ".chunk.css";
};